import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "circle",
  "use": "circle-usage",
  "viewBox": "0 0 384 448",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 384 448\" id=\"circle\"><path d=\"M384 224c0 106-86 192-192 192S0 330 0 224 86 32 192 32s192 86 192 192z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/circle.svg
// module id = DC6F
// module chunks = 1